import { render, staticRenderFns } from "./partmodule.vue?vue&type=template&id=6d0a23f3&scoped=true&"
import script from "./partmodule.vue?vue&type=script&lang=js&"
export * from "./partmodule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0a23f3",
  null
  
)

export default component.exports